import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import CoursesPage from '../views/CoursesPage.vue';
import CourseDetails from "../components/CoursesPage/CourseDetails.vue";
import LoginView from '../views/LoginView.vue';
import Register from '../views/Register.vue';
import PassCode from '../views/PassCode.vue';
import ForgetPass from '../views/ForgetPass.vue';
import NewPass from '../views/NewPass.vue';
import Profile from '../views/Profile.vue';
import Exams from '../views/Exams.vue';
import LessonsVideo from '../views/LessonsVideo.vue';
import Lessons from '../views/Lessons.vue';
import OneExam from '../views/OneExam.vue';
import OneHw from '../views/OneHw.vue';
import HomeWork from '../views/HomeWork.vue';
import store from '../store';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { title: 'Mekway' }
  },
  // {
  //   path: '/lessons/:id',
  //   name: 'LessonDetails',
  //   component: LessonDetails,
  //   meta: { title: 'Lesson Details' }
  // },
  { 
    path: "/courses", 
    name: "Courses", 
    component: CoursesPage,
    meta: { title: 'الكورسات' }
  },
  { 
    path: "/courses/:id", 
    name: "CourseDetails", 
    component: CourseDetails, 
    props: true,
    meta: { title: 'تفاصيل الكورس' }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: 'تسجيل الدخول' }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { title: 'تسجيل' }
  },
  {
    path: '/passcode',
    name: 'PassCode',
    component: PassCode,
    meta: { title: 'رمز التحقق' }
  },
  {
    path: '/forgetpass',
    name: 'ForgetPass',
    component: ForgetPass,
    meta: { title: 'نسيت كلمة المرور' }
  },
  {
    path: '/newPass',
    name: 'NewPass',
    component: NewPass,
    meta: { title: 'كلمة مرور جديدة' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { title: 'الملف الشخصي' ,  requiresAuth: true}
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  },
  {
    path: '/exams',
    name: 'Exams',
    component: Exams,
    meta: { title: 'الاختبارات',  requiresAuth: true }
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  },
  {
    path: '/videos/:lesson_id',
    name: 'LessonsVideo',
    component: LessonsVideo,
    meta: { title: 'فيديو الدروس' }
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  },
  {
    path: '/lessons',
    name: 'Lessons',
    component: Lessons,
    meta: { title: 'الدروس' }
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  },
  {
    path: '/exam/:id',
    name: 'OneExam',
    component: OneExam,
    meta: { title: 'الاختبارات' }
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  },
  {
    path: '/homework/:id',
    name: 'OneHw',
    component: OneHw,
    meta: { title: 'الواجبات' }
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  },
  {
    path: '/homework',
    name: 'HomeWork',
    component: HomeWork,
    meta: { title: 'الواجبات' }
    // meta: {
    //   requiresAuth: true // Optional: if you want to protect this route
    // }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Mekway';
const isLoggedIn = store.getters.isLoggedIn;

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ name: 'Login' });
  } else {
    next();
  }
});


// redirect to another website
// router.beforeEach((to, from, next) => {
//   if (document.referrer === '' && to.path === '/') {
//     window.location.href = 'https://geomekawy.top/?v=ffa3f4e472a2';
//   } else {
//     next();
//   } 
// });

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // Check if user is authenticated
//     if (!store.state.user) {
//       // Redirect to login page if not authenticated
//       next({ name: 'Login' });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

export default router;
